import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase';
import JSZip from 'jszip';

const COLLECTIONS = [
  'cauciones_contratos',
  'cauciones_polizas',
  'cauciones_certificados',
  'cauciones_redeterminaciones',
  'cauciones_documentos',
  'ppto_projects',
  'ppto_zones',
  'ppto_items',
  'ppto_products',
  'ppto_categories',
  'ppto_units',
  'ppto_settings',
  'casos',
  'groups',
  'meetings',
];

export async function exportTenantData(tenantId, tenantName) {
  const zip = new JSZip();
  const summary = { tenant_id: tenantId, tenant_name: tenantName, exported_at: new Date().toISOString(), collections: {} };

  for (const col of COLLECTIONS) {
    try {
      const q = query(collection(db, col), where('tenant_id', '==', tenantId));
      const snap = await getDocs(q);
      const docs = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      if (docs.length > 0) {
        zip.file(`${col}.json`, JSON.stringify(docs, null, 2));
        summary.collections[col] = docs.length;
      }
    } catch (e) {
      console.warn(`Error exportando ${col}:`, e);
    }
  }

  zip.file('_resumen.json', JSON.stringify(summary, null, 2));

  const blob = await zip.generateAsync({ type: 'blob' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `obracore-export-${tenantId}-${new Date().toISOString().split('T')[0]}.zip`;
  a.click();
  URL.revokeObjectURL(url);

  return summary;
}